"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
window.toggleDebug = function () {
    if (window.FOS_DebugOn) {
        window.FOS_DebugOn = false;
        window.localStorage.removeItem('debug');
    }
    else {
        window.FOS_DebugOn = true;
        window.localStorage.setItem('debug', true);
    }
};
function printTimingsAndMeta(url, headers, startTime, meta) {
    if (window.FOS_DebugOn || window.localStorage.getItem('debug')) {
        var fullFETiming = ((Date.now() - startTime) / 1000).toFixed(2);
        var middleTierTiming = headers["middle-tier-time"], plxRequestTiming = headers["plx-time"], authTime = headers["auth-time"];
        console.log('----------------------------');
        console.log('REQUEST TIMINGS FOR URL: ', url);
        console.log('Resolve Auth Time: ', authTime, 'seconds');
        console.log('PLX Response Time: ', plxRequestTiming, 'seconds');
        console.log('Middle Tier Response Time: ', middleTierTiming, 'seconds');
        console.log('Round Trip Response Time: ', fullFETiming, 'seconds');
        if (meta) {
            Object.keys(meta).forEach(function (val) {
                console.log("".concat(val, ": "), meta[val]);
            });
        }
        console.log('----------------------------');
    }
}
exports.default = printTimingsAndMeta;
